import * as React from "react";
import { Link } from "gatsby";
import * as styles from "/src/components/Project/ProjectSummary.module.css";
import slugify from "slugify";

import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ProjectSummary = (props) => {
  const items = {
    header: props.data.node.title,
    summary: props.data.node.summary,
    meta: props.data.node.category,
    image: props.data.node.images,
  };
  const imageArray = props.data.node.images;

  return (
    <Link
      className={styles.wholeLink}
      to={`/projects/${slugify(props.data.node.title, {
        lower: true,
        strict: true,
      })}`}
    >
      <div className={styles.projectlistboxes}>
        <div className={styles.imageformat}>
          <GatsbyImage
            className={styles.imagery}
            image={getImage(imageArray[0].gatsbyImageData)}
            alt={imageArray[0].description}
          />
          <h1>{props.data.node.title}</h1>
          <hr />
        </div>
        <div className={styles.imagecaption}>
          <p style={{ margin: 0 }}>See what we've been up to! </p>
          <div className={styles.linebreak}>
            <hr style={{ margin: 0, width: 190 }} />
          </div>
          <div>
            <div className={styles.projectcat}>
              <div>{items.meta}</div>
            </div>
          </div>
          <div className={styles.projectdescription}>{items.summary}</div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectSummary;
